import { fromEntries } from 'helpers/object';

export const validateFields = (validator, fieldNames) => formData =>
  fromEntries(
    fieldNames
      .map(fieldName => [fieldName, validator(formData[fieldName], formData)])
      .filter(([, errorMessage]) => !!errorMessage)
  );
